export const replaceAll = (str, find, replace) => {
    const escapeRegExp = (innerStr) => innerStr.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
};
//# sourceMappingURL=replaceAll.js.map